import {Loader} from "semantic-ui-react"
import * as React from "react"
import {errorUnionToEither, handleError} from "../graphql/errors"
import {ModalStore} from "../actions"
import {repeatBookingProperties, returnBookingProperties} from "../model/booking"
import {AddBookingWizard} from "./AddBookingWizard"
import {Booker, Booking, DefaultLocale} from "../graphql/queries"
import {GraphQL} from "../graphql"
import {resolveLocale, UrlLocaleIdProp} from "../urlLocale"

type RepeatOrReturn = "repeat" | "return"

interface Props extends UrlLocaleIdProp {
  mode: RepeatOrReturn
  bookingNumber: string
  modalStore: ModalStore
}

export function RepeatReturnBooking(props: Props) {
  return (
    <GraphQL.Query
      query={Booking}
      variables={{number: props.bookingNumber}}
      render={({data: booking}) => (
        <GraphQL.Query
          query={Booker}
          variables={{}}
          render={({data: booker}) => (
            <GraphQL.Query
              query={DefaultLocale}
              variables={{
                id: props.urlLocaleId
              }}
              render={({data: defaultLocale}) => {
                if (booking === null || booker === null || defaultLocale === null) {
                  return <Loader active />
                }
                return handleError(errorUnionToEither(booking.booking), (booking) =>
                  handleError(errorUnionToEither(booker.booker), (booker) => {
                    const locale = resolveLocale(
                      props.urlLocaleId,
                      booker.booker,
                      defaultLocale.defaultLocale,
                    )
                    function createState() {
                      switch (props.mode) {
                        case "repeat":
                          return repeatBookingProperties(booking, locale)
                        case "return":
                          return returnBookingProperties(booking, locale)
                      }
                    }
                    return (
                      <AddBookingWizard
                        urlLocaleId={props.urlLocaleId}
                        isRepeatOrReturn={true}
                        modalStore={props.modalStore}
                        initialState={createState()}
                        onState={() => undefined}
                        onSave={() => undefined}
                      />
                    )
                  }),
                )
              }}
            />
          )}
        />
      )}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/RepeatReturnBooking.tsx